// extracted by mini-css-extract-plugin
module.exports = {"iconBtn":"IconButton_iconBtn__3gRli","tooltip":"IconButton_tooltip__PcjJw","tooltiptext":"IconButton_tooltiptext__3wlf_","btnWrapper":"IconButton_btnWrapper__3G8q8"};